import axios from 'axios';

const client = axios.create({
    withCredentials: true,
});

async function getContent(props) {
    const { data } = await client.post('getContent', props);
    return data;
}

var methods = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getContent: getContent
});

/**
 * Initialize the CraftCms connector.
 */
const craftCmsConnector = (options) => {
    client.defaults.baseURL = options.apiUrl;
    client.defaults.headers.common = options.headers;
    return methods;
};

/**
 * CraftCms module.
 */
const craftCmsModule = (options) => ({
    connector: craftCmsConnector({
        apiUrl: options.apiUrl,
        headers: options.headers,
    }),
    utils: {},
    subscribers: {},
});

export { client, craftCmsModule };
